import React, { useState } from "react";
import PropTypes from "prop-types";
import Loader from 'components/general/Loader'
import { useSelector, useDispatch } from 'react-redux'
import { componentIntermediateSelector } from 'state-management/actions'
import { getGlobalProps } from 'state-management/selectors'
import Label from "components/general/Label";

import {
    useTable,
    useSortBy,
    useGlobalFilter,
    useFilters,
    useResizeColumns,
    // useFlexLayout,
    usePagination,
    useExpanded,
    useRowState
} from "react-table";
import {
    Table,
    Row,
    Col,
    InputGroup,
    FormControl,
    Button,
    Container

} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faArrowDown,
    faArrowUp,
    faArrowsUpDown,
    faAngleLeft,
    faAngleRight,
    faAngleDoubleLeft,
    faAngleDoubleRight,

} from "@fortawesome/free-solid-svg-icons";
import GlobalFilter from "./GlobalFilter";
import ColumnFilter from "./ColumnFilter";
import useViewport from "../useViewPort";


function useInstance(instance) {
    const { allColumns } = instance;
    let rowSpanHeaders = [];
    allColumns.forEach((column, i) => {
        const { id, enableRowSpan } = column;
        if (enableRowSpan === true || id === "Expander") {
            rowSpanHeaders = [
                ...rowSpanHeaders,
                { id, topCellValue: null, topCellIndex: 0 }
            ];
        }
    });

    Object.assign(instance, { rowSpanHeaders });
}



const NavbarSplits = ({ columnIndex, setColumnIndex, numColumns, numExtendedColsVisible, hasTimeline }) => {


    const globalProps = useSelector(getGlobalProps)
    const dispatch = useDispatch();

    //if (!show) return null
    let index = Number(columnIndex);
    let blocksColumns = [];


    if (isNaN(numExtendedColsVisible) && String(numExtendedColsVisible).includes(",")) {
        blocksColumns = numExtendedColsVisible.split(',');
    }

    const handleColumnIncrement = () => {
        //Show hide columns by blocks numColumns.includes(",")
        if (isNaN(numExtendedColsVisible) && String(numExtendedColsVisible).includes(",")) {
            index = (index < blocksColumns.length) ? index + 1 : index
        } else {
            index = (index < numColumns) ? index + 1 : index;
        }
        setColumnIndex(index)
        hasTimeline && updateReduxData(index)

    }
    const handleColumnDecrement = () => {

        if (isNaN(numExtendedColsVisible) && String(numExtendedColsVisible).includes(",")) {
            index = (index > 1) ? index - 1 : 1;
        } else {
            index = index > numExtendedColsVisible ? index - 1 : numExtendedColsVisible;
        }
        setColumnIndex(index)
        hasTimeline && updateReduxData(index)
    }


    const updateReduxData = (index) => {
        let intermediateSelector = Object.assign({}, globalProps.intermediateSelector);
        intermediateSelector.selected = index;
        intermediateSelector.isLive = false
        dispatch(componentIntermediateSelector(intermediateSelector))
    }



    return (
        <nav>
            <button className='splits' onClick={() => handleColumnDecrement()}><FontAwesomeIcon className="font-icon" icon={faAngleLeft} /></button>
            {/*<span>{index}/{columnIndex}/{blocksColumns.length}</span>*/}
            <button className='splits' onClick={() => handleColumnIncrement()}><FontAwesomeIcon className="font-icon" icon={faAngleRight} /></button>
        </nav>
    );
};



// Create a default prop getter
const defaultPropGetter = () => ({})

const MirsTable = ({
    sortable = true,
    columns: userColumns,
    data,
    renderRowSubComponent,
    rowOnClick,
    rowClickHandler,
    showGlobalFilter,
    expandRows,
    expandedRowObj,
    keyRow,
    hiddenColumns,
    colIndex,
    colsExtendedVisible,
    hasRelatedTimeline,
    caption,
    classCaption,
    extendedComponents,
    showNavExtendedData,
    showLoading,
    initialSortBy,
    id,
    className,
    theadClassName,
    tbodyClassName,
    discipline,
    showPagination,
    pageSizeCustom,
    getHeaderProps = defaultPropGetter,
    getColumnProps = defaultPropGetter,
    getRowProps = defaultPropGetter,
    getCellProps = defaultPropGetter,


}) => {
    const [columnIndex, setColumnIndex] = useState(colIndex === undefined ? 1 : colIndex)
    const [numExtendedColsVisible, setNumExtendedColsVisible] = useState(colsExtendedVisible === undefined ? 1 : colsExtendedVisible)
    const [numExtendedColsVisibleChange, setNumExtendedColsVisibleChange] = useState(false)

    const [hasTimeline, sethasTimeline] = useState(hasRelatedTimeline === undefined ? false : hasRelatedTimeline)
    const [showNavExtendedDataInternal, setShowNavExtendedDataInternal] = useState(showNavExtendedData === undefined ? false : showNavExtendedData)
    //const [showLoadingInternal, setShowLoadingInternal] = useState(showLoading === undefined ? false : showLoading)
    const showLoadingInternal = showLoading === undefined ? false : showLoading;
    const [tableLoading, setTableLoading] = useState(false);
    const globalProps = useSelector(getGlobalProps)
    const { breakPoint } = useViewport();
    const isMobile = breakPoint === "sm" || breakPoint === "xs" 
    const filterTypes = React.useMemo(
        () => ({
            includes: (rows, id, filterValue) => {
                return rows.filter((row) => {
                    const rowValue = row.values[id];
                    return rowValue !== undefined
                        ? String(rowValue)
                            .toLowerCase()
                            .includes(String(filterValue).toLowerCase())
                        : true;
                });
            },

            startsWith: (rows, id, filterValue) => {
                return rows.filter((row) => {
                    const rowValue = row.values[id];
                    return rowValue !== undefined
                        ? String(rowValue)
                            .toLowerCase()
                            .startsWith(String(filterValue).toLowerCase())
                        : true;
                });
            }
        }),
        []
    );

    const sortTypes = React.useMemo(
        () => ({
            dateSort: (a, b) => {
                a = new Date(a).getTime();
                b = new Date(b).getTime();
                return b > a ? 1 : -1;
            },


            absoluteOrderNumber(rowA, rowB, columnId, desc) {
                let a = (typeof (rowA.values[columnId]) === 'string' || rowA.values[columnId] instanceof String) ? rowA.values[columnId].trim() : rowA.values[columnId]
                let b = (typeof (rowB.values[columnId]) === 'string' || rowB.values[columnId] instanceof String) ? rowB.values[columnId].trim() : rowB.values[columnId]

                if ((a === null || a === '') && (b !== null || b !== '')) {
                    return desc ? -1 : 1;
                }

                if ((a !== null || a !== '') && (b === null || b === '')) {
                    return desc ? 1 : -1;
                }

                if ((a === null || a === '') && (b === null || b === '')) {
                    return 0;
                }


                return a - b
            },

        }),



        []
    );

    const defaultColumn = React.useMemo(
        () => ({
            Filter: ColumnFilter,
            disableFilters: true,
            minWidth: 30,
            width: 150,
            maxWidth: 500,
            disableSortBy: true,
        }),
        []
    );


    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        rows, //rows return all rows 
        page, //has only the rows for the active page

        setGlobalFilter,
        rowSpanHeaders,
        setHiddenColumns,
        setSortBy,
        //Pagination elements  
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { globalFilter, pageIndex, pageSize }
    } = useTable(
        {

            columns: userColumns,
            data,
            initialState: {
                pageSize: pageSizeCustom,
                sortBy: initialSortBy,
                expanded:
                    expandRows && expandedRowObj.hasOwnProperty(0) ? expandedRowObj : {},
                hiddenColumns: hiddenColumns //initialize hide columns id
            },
            defaultColumn,
            filterTypes,
            sortTypes,
            autoResetRowState: false,
            autoResetSortBy: false,
            autoResetExpanded: false,
            //getResetExpandedDeps: false
            disableSortRemove: true,
            disableSortBy: isMobile
        },
        //Rowspan
        hooks => { hooks.useInstance.push(useInstance); },
        useGlobalFilter,
        useFilters,
        useSortBy,
        useResizeColumns,
        useExpanded,
        useRowState,
        showPagination ? usePagination : ''
        //useFlexLayout
    );


    const obj = showPagination ? page : rows;


    //Forzamos cuando cambiamos solo las columnas a cambiar la ordenacion
    // si no ponemos esto la inicializacion de la tabla coge el valor de ordenacion por defecto pero cuando se cambia ese valor inicial no fuerza la reordenacion
    React.useEffect(() => {
        setSortBy(initialSortBy)
    }, [initialSortBy, setSortBy])

    React.useEffect(() => {
        if (hasTimeline && globalProps.intermediateSelector.selected) {
            let currentSplit =
                ((globalProps.intermediateSelector.selected) === 'F')
                    ? globalProps.intermediateSelector.finalPosition
                    : globalProps.intermediateSelector.selected
            currentSplit = currentSplit < globalProps.intermediateSelector.extendedColsVisibles ? globalProps.intermediateSelector.extendedColsVisibles : currentSplit
            setColumnIndex(currentSplit)

        } else {
            //Revisar es necesario????
            colIndex = colIndex === undefined ? 1 : colIndex
            colIndex = colIndex < numExtendedColsVisible ? numExtendedColsVisible : colIndex
            setColumnIndex(colIndex)
        }

    }, [colIndex, numExtendedColsVisibleChange, hasTimeline, globalProps.intermediateSelector.selected])

    React.useEffect(() => {
        if (hasTimeline && globalProps.intermediateSelector.extendedColsVisibles) {
            setNumExtendedColsVisible(globalProps.intermediateSelector.extendedColsVisibles)
        } else {
            setNumExtendedColsVisible(colsExtendedVisible)
            //setColumnIndex(colIndex);
        }
        setNumExtendedColsVisibleChange(!numExtendedColsVisibleChange)//Force sow/hide columns  when numExtendedColsVisibles Change 
    }, [colsExtendedVisible, hasTimeline, globalProps.intermediateSelector.extendedColsVisibles])

    //useEffect cambio status
    React.useEffect(() => {
        setTableLoading(showLoadingInternal);
        const timer = setTimeout(() => {

            setTableLoading(false);
        }, 300);

        return () => {
            clearTimeout(timer);
        };
    }, [userColumns]);

    //Hide columns Splits + hiddenColumns +columns isVisible=false
    React.useEffect(() => {
        let blocksColumns = [];
        let ini = 1;
        let fin = 0;

        let colSplits = userColumns.filter(cell => (cell.hasOwnProperty('columnIndex'))).length;
        if (
            ((!isNaN(numExtendedColsVisible) && (colSplits > 0)) && (colSplits > numExtendedColsVisible))
            || ((isNaN(numExtendedColsVisible)) && (String(numExtendedColsVisible).includes(",")))) {
            setShowNavExtendedDataInternal(true)
        } else {
            setShowNavExtendedDataInternal(false)
        }


        if (isNaN(numExtendedColsVisible) && String(numExtendedColsVisible).includes(",")) {
            blocksColumns = numExtendedColsVisible.split(',');
            if (columnIndex === 1) {
                ini = 1;
            } else {
                for (let i = 0; i < columnIndex - 1; i++) {
                    ini += Number(blocksColumns[i])
                }
            }
            fin = (ini + Number(blocksColumns[columnIndex - 1])) - 1;

        }

        //Ponemos todas las columnas en un array, 
        //cuando tienen span hay que buscar en las columnas agrupadas las columnas hijas,
        //sino solo devuelve como columnas las que estan en la fila 1
        let realColumns = [];
        userColumns.forEach(cell => {
            if (cell?.columns) {
                realColumns = [...realColumns, ...cell.columns]
            } else {
                realColumns.push(cell);
            }
        })

        let hiddenCols = [...hiddenColumns,
        ...realColumns.filter(cell =>
            (cell.isVisible === false && !cell.hasOwnProperty('columnIndex')) ||
                (blocksColumns.length > 0)
                ? (cell.isVisible === false && cell.columnIndex < ini) || (cell.columnIndex > fin)
                : (cell.isVisible === false) && (cell.columnIndex < Number(columnIndex) - (numExtendedColsVisible - 1) || cell.columnIndex > Number(columnIndex))
        ).map(cell => {
            return cell.id
        })
        ];
        setHiddenColumns(hiddenCols)

    }, [columnIndex, hiddenColumns, numExtendedColsVisible, userColumns]
    );

    if (tableLoading) { return <Loader />; }


    function getJsonData(key, i, row) {
        try {
            if (key !== undefined && key !== '') {
                return key.split('-').reduce((a, i) => a[i], row.original);
            } else {
                return id + "_" + i;
            }
        } catch (error) {
            return (id + "_" + i)
        }
    }

    //Clculo de numero de columnas    
    let _colNums = 0;
    userColumns.forEach(col => {
        if (col?.columns) {
            _colNums = _colNums + col?.columns.length;
        } else {
            _colNums = _colNums + 1;
        }

    })



    return (
        <React.Fragment>
            {showGlobalFilter ? (
                <Row className="float-end">
                    <Col>
                        <div className="d-flex justify-content-end mb-2">
                            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
                        </div>
                    </Col>
                </Row>
            ) : (
                ""
            )}



            {showNavExtendedData ? (
                <div className='table-components d-flex justify-content-end navbar-splits'>


                    {extendedComponents}


                    <div className="p-2 ">
                        {/* Check if is necesary show navbar(enought intermediate poinsts) */}
                        {showNavExtendedDataInternal ? <NavbarSplits
                            //show={showNavExtendedDataInternal}
                            columnIndex={columnIndex}
                            setColumnIndex={setColumnIndex}
                            numColumns={userColumns.filter(cell => cell.isVisible === false && cell.columnIndex !== undefined).length}
                            numExtendedColsVisible={numExtendedColsVisible}
                            hasTimeline={hasTimeline}
                        /> : ''}
                    </div>




                </div>
            ) : ''}


            <Row>
                <Col>
                    {/*                     <Table striped bordered responsive="md"*/}
                    <Table striped bordered className={className} id={id} discipline={discipline}
                        {...getTableProps()}
                    >
                        {caption &&
                            <caption className={classCaption}>
                                {caption}
                            </caption>
                        }
                        <thead className={theadClassName}>
                            {headerGroups.map((headerGroup, i) => {

                                return (
                                    <React.Fragment key={i + "_hfrag"}>
                                        <tr {...headerGroup.getHeaderGroupProps()}>
                                            {/* Filtramos con la propiedad sort de la columna para no mostrar la columna*/}
                                            {headerGroup.headers.map((column, id) => {
                                                const aux = column
                                                if (aux.enableRowSpan && headerGroups.length > 1) {
                                                    const col = headerGroups.length > 1 && headerGroups[1]?.headers.find(item => item.id === aux.relatedId)
                                                    column = col;
                                                    column.headerClassName = aux.headerClassName;
                                                    column.rowSpan = 2;
                                                }

                                                if (aux.remove) {
                                                    column.headerClassName = "d-none"
                                                }


                                                let cAlign = '';
                                                if (column?.headerClassName && column?.headerClassName.includes("text-end")) {
                                                    cAlign = 'w-100 text-end';
                                                }
                                                if (column?.headerClassName && column?.headerClassName.includes("text-center")) {
                                                    cAlign = 'w-100 text-center';
                                                }


                                                return (
                                                    <th
                                                        {...column.getHeaderProps([

                                                            {
                                                                rowSpan: column.rowSpan,
                                                                key: column.id,
                                                                style: { ...column.style },
                                                                //style: { verticalAlign: 'middle' },
                                                                className: column.headerClassName,
                                                                mirsid: column.id,
                                                            },
                                                            getColumnProps(column),
                                                            getHeaderProps(column),
                                                            column.getSortByToggleProps()

                                                        ])}
                                                    >
                                                        <div className="d-flex ">
                                                            <span className={cAlign}>
                                                                {column.render("Header")}
                                                            </span>
                                                            {column.canSort ? (
                                                                <span className="svg-mirs align-self-center">
                                                                    {column.isSorted ? (
                                                                        column.isSortedDesc ? (
                                                                            <FontAwesomeIcon
                                                                                className="ms-3"
                                                                                icon={faArrowDown}
                                                                            />
                                                                        ) : (
                                                                            <FontAwesomeIcon
                                                                                className="ms-3"
                                                                                icon={faArrowUp}
                                                                            />
                                                                        )

                                                                    ) : (
                                                                        <FontAwesomeIcon
                                                                            className="ms-3"
                                                                            icon={faArrowsUpDown}
                                                                        />
                                                                    )}
                                                                </span>
                                                            ) : ''}
                                                        </div>

                                                        <div
                                                            {...column.getResizerProps()}
                                                            className="resizer"
                                                        />
                                                        {column.canResize && (
                                                            <div
                                                                {...column.getResizerProps()}
                                                                className={`resizer ${column.isResizing ? "isResizing" : ""}`}
                                                            />
                                                        )}
                                                        <div>
                                                            {column.canFilter ? column.render("Filter") : null}
                                                        </div>
                                                    </th>
                                                )

                                            })}
                                        </tr>
                                    </React.Fragment>
                                )
                            })}
                        </thead>
                        <tbody {...getTableBodyProps()} className={tbodyClassName}>
                            {obj.map((row, i) => {
                                prepareRow(row);
                                //  let rowCanExpanded = false;
                                for (let j = 0; j < row.allCells.length; j++) {
                                    let cell = row.allCells[j];

                                    let rowSpanHeader = rowSpanHeaders.find(
                                        x => x.id === cell.column.id
                                    );

                                    if (rowSpanHeader !== undefined) {

                                        let props = {}
                                        props["cell"] = {}
                                        props["cell"]["row"] = {}
                                        props["cell"]["row"]["original"] = row.original

                                        let cellValue = (typeof cell.value === 'object')
                                            ? cell.value.rowSpanId
                                            : cell.column.rowSpanType === 'accesor' ? cell.value : cell.column.Cell(props);

                                        if (
                                            rowSpanHeader.topCellValue === null ||
                                            rowSpanHeader.topCellValue !== cellValue
                                        ) {

                                            if (typeof cell.value === 'object') {
                                                rowSpanHeader.topCellValue = cell.value.rowSpanId;
                                            } else {
                                                rowSpanHeader.topCellValue = cellValue
                                            }
                                            cell.isRowSpanned = false;
                                            rowSpanHeader.topCellIndex = i;
                                            cell.rowSpan = 1;
                                        } else {
                                            obj[rowSpanHeader.topCellIndex].allCells[j].rowSpan++;
                                            cell.isRowSpanned = true;
                                        }
                                    }

                                    //miramos si tiene elemento s a mostrar para poder expandirse 
                                    //sino siempre hara un expand cuando hagamos un expand all y mostrarauna fila vacia 
                                    //o con el componente cuando no tiene el icono indicativo
                                    if (cell.column.id === 'Expander') {
                                        row.rowCanExpanded = !!cell.value.rowCanExpand
                                    }
                                }
                                return null;
                            })}


                            {obj.map((row, i) => {
                                return (
                                    <React.Fragment key={getJsonData(keyRow, i, row) !== undefined ? `${getJsonData(keyRow, i, row)}_frag` : `${keyRow}_${i}_frag`}>

                                        <tr data-key={getJsonData(keyRow, i, row) + "_row"}
                                            {...row.getRowProps(getRowProps(row))}
                                            onClick={
                                                rowOnClick
                                                    ? () => rowClickHandler(row.original)
                                                    : () => ""
                                            }
                                        >

                                            {row.cells.map((cell) => {
                                                if (cell.isRowSpanned)
                                                    return null;
                                                else
                                                    return (
                                                        <td {...cell.getCellProps([
                                                            {
                                                                rowSpan: cell.rowSpan,
                                                                className: cell.column.className,
                                                                style: cell.column.style
                                                            },
                                                            getColumnProps(cell.column),
                                                            getCellProps(cell)
                                                        ])}
                                                        >
                                                            {cell.render("Cell")}
                                                        </td>
                                                    );
                                            })}
                                        </tr>

                                        {row.isExpanded && row.rowCanExpanded ? (
                                            <tr data-key={getJsonData(keyRow, i, row) + "_expanded"} >
                                                <td className="mirs-expander" colSpan={_colNums}>
                                                    {renderRowSubComponent({ row })}
                                                </td>
                                            </tr>
                                        ) : null}
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </Table>

                    {/**  INICIO Pagination */}
                    {showPagination ? (
                        <Container>
                            <Row className="mt-2 text-center align-items-center">
                                <Col>
                                    <Button
                                        className="me-2"
                                        size="sm"
                                        variant="secondary"
                                        onClick={() => gotoPage(0)}
                                        disabled={!canPreviousPage}
                                    >
                                        <FontAwesomeIcon icon={faAngleDoubleLeft} />
                                    </Button>

                                    <Button
                                        className="me-2"
                                        size="sm"
                                        variant="secondary"
                                        onClick={() => previousPage()}
                                        disabled={!canPreviousPage}
                                    >
                                        <FontAwesomeIcon icon={faAngleLeft} />
                                    </Button>
                                </Col>
                                <Col>
                                    <span className="pe-3">
                                        <Label data="page-of" values={{ page: pageIndex + 1, pageTotal: pageOptions.length }} ></Label>
                                    </span>
                                    <span className="pe-3">
                                        | <Label data="GoToPage" />
                                        <InputGroup
                                            size="sm"
                                            style={{ width: "20%", display: "inline-flex" }}
                                        >
                                            <FormControl
                                                type="number"
                                                defaultValue={pageIndex + 1}
                                                onChange={(e) => {
                                                    const page = e.target.value
                                                        ? Number(e.target.value) - 1
                                                        : 0;
                                                    gotoPage(page);
                                                }}
                                            />
                                        </InputGroup>
                                    </span>
                                    <span className="pe-3">
                                        <InputGroup
                                            size="sm"
                                            style={{ width: "30%", display: "inline-flex" }}
                                        >
                                            <FormControl
                                                size="sm"
                                                as="select"
                                                value={pageSize}
                                                onChange={(e) => {
                                                    setPageSize(Number(e.target.value));
                                                }}
                                            >
                                                {[5, 10, 20, 30, 40, 50].map((pageSize) => (
                                                    <option key={pageSize} value={pageSize}>
                                                        Show {pageSize}
                                                    </option>
                                                ))}
                                            </FormControl>
                                        </InputGroup>
                                    </span>
                                    <span >{rows.length} <Label data="Elements" /></span>
                                </Col>
                                <Col>
                                    <Button
                                        className="me-2"
                                        size="sm"
                                        variant="secondary"
                                        onClick={() => nextPage()}
                                        disabled={!canNextPage}
                                    >
                                        <FontAwesomeIcon icon={faAngleRight} />
                                    </Button>
                                    <Button
                                        className="me-2"
                                        size="sm"
                                        variant="secondary"
                                        onClick={() => gotoPage(pageCount - 1)}
                                        disabled={!canNextPage}
                                    >
                                        <FontAwesomeIcon icon={faAngleDoubleRight} />
                                    </Button>
                                </Col>
                            </Row>
                        </Container>
                    ) : (
                        ""
                    )}




                    {/**  END Pagination */}

                </Col>
            </Row>
        </React.Fragment >
    );
};

MirsTable.defaultProps = {
    rowOnClick: false,
    showNavExtendedData: false,
    expandRows: false,
    expandedRowObj: {},
    hiddenColumns: [],
    initialSortBy: [{ id: 'Rank', desc: false }],
    pageSizeCustom: 10,
    showPagination: false,
    data: []

};

MirsTable.propTypes = {

    /** Specifies if there should be a row onClick action*/
    rowOnClick: PropTypes.bool.isRequired,

    /** OPTIONAL: The onClick Action to be taken */
    rowClickHandler: PropTypes.func,

    /** header color background. There are six possible choices. Refer to ReadMe file for specifics */
    headerColor: PropTypes.string,

    /** Specified if pagination should show or not */
    showPagination: PropTypes.bool.isRequired,

};

export default MirsTable;
